<script setup>
import TransactionCreate from "./transaction-create.vue";
import {computed, onMounted, ref} from "vue"
import TransactionDetails from "./transaction-details.vue";
import helpers from "@/lib/helpers";
import TransactionRefund from "./transaction-refund.vue";

const emits = defineEmits(['submit'])

const props = defineProps({
  order: Object,
  url: [Object, String],
  refresh: Function,
  refund: Object
})

const stack = ref([])
const transaction = ref(null)
const init = ref(true)
const refund = ref(null)
const update = async (replace) => {
  if (replace)
    transaction.value = replace
  else
    transaction.value = await helpers.asyncAction(transaction.value._links.self_url)

  props.refresh && props.refresh()
}

onMounted(() => {
  if (props.url)
    push(props.url)
  else
    init.value = false
})

const push = async (r) => {
  refund.value = null

  if (r instanceof Object) {
    transaction.value = r
  } else {
    transaction.value = await helpers.asyncAction(r, 'get')
  }
  stack.value.unshift(transaction.value._links.self_url.href)
  init.value = false

  props.refresh && props.refresh()
}

const title = computed(() => {
  return 'Transaction'
})

const back = async () => {
  if (refund.value) {
    refund.value = null
  } else {
    stack.value.shift()

    if (stack.value.length)
      transaction.value = await helpers.asyncAction(stack.value[0], 'get')
    else
      transaction.value = null
  }
}

const do_refund = (r) => {
  refund.value = r
}
</script>

<template>
  <modal :title="title" height="400px">
    <template #buttons>
      <b-button v-if="(refund && stack.length) || (stack.length > 1)" variant="link"
                class="text-white d-none d-sm-inline" size="sm"
                @click="back">BACK
      </b-button>
    </template>

    <transaction-refund v-if="!init && !!refund" @created="push" :order="order" :parent="refund" @pending="back"/>
    <transaction-create v-else-if="!init && !transaction" :order="order" @created="push"/>
    <transaction-details v-else-if="!!transaction" :value="transaction" @input="update" :order="order"
                         @refund="do_refund" @submit="$emit('submit')"
                         @push="push"/>
  </modal>
</template>

<style scoped>

</style>